<template>
  <div>
    <v-toolbar class="toolbar-element" light absolute flat height="90em">
      <v-toolbar-title class="toolbar-title">Notificación a club(es)</v-toolbar-title>
    </v-toolbar>
    <v-card class="spacing-top" v-if="loading">
      <v-flex offset-xs5 pa-5>
        <v-progress-circular :size="100" :width="5" color="primary" indeterminate></v-progress-circular>
      </v-flex>
    </v-card>
    <v-card class="spacing-top px-2 custom-font-regular" v-else>
      <v-card-text>
        <div class="title-form mt-2">Plazo de apelación</div>
        <v-divider class="mt-2 mb-3"></v-divider>
        <v-layout row wrap>
          <v-flex xs6 pr-2><DatePickerForm v-model="termDate" :error-messages="termDateErrors"></DatePickerForm></v-flex>
          <v-flex xs6 pl-2><TimePickerForm v-model="termTime" :error-messages="termTimeErrors"></TimePickerForm></v-flex>
        </v-layout>
        <v-divider class="mt-5 mb-2"></v-divider>
        <ConfirmationDialog :function-yes="bindingFunction" ref="confirm" title="Abandonar página"
                            text="Se perderán los cambios del formulario actual, ¿desea continuar?"></ConfirmationDialog>
        <v-card-actions>
          <v-btn color="grey" depressed :disabled="saving" @click="goBackConfirmation">Volver</v-btn>
          <v-spacer></v-spacer>
          <v-btn @click="submit" depressed color="primary" :disabled="saving">Enviar</v-btn>
        </v-card-actions>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import { createEntityMixin } from '../../../mixins/createEntityMixin'
import ConfirmationDialog from '../../../common/ui/ConfirmationDialog'
import DatePickerForm from '../../../common/ui/DatePickerForm'
import TimePickerForm from '../../../common/ui/TimePickerForm'

export default {
  mixins: [validationMixin, createEntityMixin],

  props: {
    prefixCreatePath: {
      type: String,
      default: 'case_file/notify_committee/'
    }
  },

  validations () {
    return {
      termDate: { required },
      termTime: { required }
    }
  },

  components: {
    ConfirmationDialog,
    DatePickerForm,
    TimePickerForm
  },

  data () {
    return {
      termDate: null,
      termTime: null,
      axiosMethod: this.axios.put
    }
  },

  computed: {
    createPath () {
      return this.prefixCreatePath + this.$route.params.id
    },
    isEditing () {
      return false
    },
    termDateErrors () {
      return this.getRequiredErrors('termDate')
    },
    termTimeErrors () {
      return this.getRequiredErrors('termTime')
    }
  },

  methods: {
    getPayload () {
      return {
        'term': `${this.termDate} ${this.termTime}`
      }
    },
    isValidForm () {
      return !this.$v.$invalid
    }
  }
}
</script>

<style scoped>
.spacing-top {
  margin-top: 6em !important;
}
.title-form {
  font-size: 1.3em;
}
</style>
